<h1 mat-dialog-title>{{ 'communications.add.cancellationDialogtitle' | translate }}</h1>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>

  <!-- Step 1 -->
  <div class="row" *ngIf="step1">
    <div class="col-12">
      <table class="table table-borderless table-striped">
        <thead>
          <th></th>
          <th>{{ 'properties.documentsPage.docType' | translate }}</th>
          <th>{{ 'properties.structures.structure' | translate }}</th>
        </thead>
        <tbody>
          <tr *ngFor="let doc of docs">
            <td>
              <mat-checkbox [checked]="doc.checked"
                (change)="onDocSelected(doc, $event.checked)" class="checkbox-insert">
              </mat-checkbox>
            </td>
            <td>
              {{ doc.docTitle }}
            </td>
            <td>
              {{ doc.structureObjectName }}
            </td>
          </tr>
        </tbody>
      </table>
      <div class=" mt-1 mb-3 ml-3">
        {{ 'properties.dialog.contractCancellation' | translate }}
      </div>
    </div>
  </div>
  <!-- Step 2 -->
  <div class="row" *ngIf="!step1">
    <!-- MESSAGE AREA -->
    <div class="col-9 form-wrapper communication-form doc-communication-form">
      <form [formGroup]="form">
        <div class="sender-info-wrapper">
          <div class="sender-label" mat-label>
            {{ 'communications.fields.sender' | translate }}
          </div>
          <span class="sender-email">
            {{ loggedUser.get("email") ? loggedUser.get("email") : '' }}
          </span>
        </div>
        <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
      </form>
    </div>

    <!-- SIDE AREA -->
    <div class="col-3">
      <!-- Contract -->
      <h4 class="mt-3">{{ 'communications.fields.contracts' | translate }}</h4>
      <div *ngIf="model.docs">
        <!-- Files -->
        <ng-container *ngFor="let doc of model.docs">
          <div class="text-wrapper">
            {{ doc.value }}
          </div>
        </ng-container>
      </div>
    </div>
  </div>

</mat-dialog-content>

<div class="row custom-dialog-footer">
  <div class="col-12 col-md-6 text-left">
    <a mat-button (click)="onClose()" mat-raised-button mat-default
      class="ml-3">{{ 'common.cta.close' | translate }}</a>
  </div> <!-- /.col -->
  <div class="col-6 text-right" *ngIf="step1 && selectedDocs.length">
    <mat-spinner-button (btnClick)="onStep2()" role="submit" [options]="formBtnOptions" class="btn-elevate">
    </mat-spinner-button>
  </div>
  <div class="col-12 col-md-6 text-right" *ngIf="!step1">
    <mat-spinner-button (btnClick)="onFormSubmit()" role="submit" [options]="formBtnOptions" class="btn-elevate">
    </mat-spinner-button>
  </div> <!-- /.col -->
</div> <!-- /.row -->